import React from 'react'
import createClass from 'create-react-class'
import PropTypes from 'prop-types'
import { Card, CardHeader, CardBody, Progress } from 'reactstrap'

const WeldData = createClass({
  propTypes: {
    weld: PropTypes.object.isRequired,
    inspectionCategoryTypes: PropTypes.array.isRequired,
  },
  renderExtraData() {
    const extraColumns = JSON.parse(this.props.weld.project.extra_columns || '{}')
    const extraData = JSON.parse(this.props.weld.extra_data || '{}')
    const extraDataKeys = Object.keys(extraColumns)
    if (Object.keys(extraColumns).length > 0) {
      return (
        <table id="weld-extra-data-table" style={{ width: `${extraDataKeys.length * 10}%` }} className='table table-condensed'>
          <thead>
            <tr>
              {extraDataKeys.map(key => <th key={key}>{extraColumns[key]}</th>)}
            </tr>
          </thead>
          <tbody>
            <tr>
              {extraDataKeys.map(key => <td key={key}>{extraData[key]}</td>)}
            </tr>
          </tbody>
        </table>
      )
    }
  },
  render() {
    const weld = this.props.weld
    const weldInspections = weld.inspection_category ? weld.inspection_category.inspections : null

    return (
      <Card>
        <CardHeader>
          <b>Weld</b>
        </CardHeader>
        <CardBody>
          <table id="weld-list-table" className='table table-condensed'>
            <thead>
              <tr>
                <th>No</th>
                <th>Weld Type</th>
                <th>Length</th>
                <th>Diameter 1</th>
                <th>Thickness 1</th>
                <th>Diameter 2</th>
                <th>Thickness 2</th>
                <th>Material 1</th>
                <th>Material 2</th>
                <th>Status</th>
                <th>Welding</th>
                <th style={{ width: '130px' }}>WPS</th>
                <th>Welding Consumables</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{weld.no}</td>
                <td>{weld.weld_joint_type && weld.weld_joint_type.map((wjt, index) => 
                  `${wjt.weld_type ? wjt.weld_type.name : ''}${wjt.joint_type ? `-${wjt.joint_type.name}` : ''}`
                ).join(', ')}</td>
                <td>{weld.length}</td>
                <td>{weld.diameter_1}</td>
                <td>{weld.thickness_1}</td>
                <td>{weld.diameter_2}</td>
                <td>{weld.thickness_2}</td>
                <td>{weld.material_1 && weld.material_1.name}</td>
                <td>{weld.material_2 && weld.material_2.name}</td>
                <td>{weld.status}</td>
                <td>
                  <Progress value={weld.welding_progress}>{weld.welding_progress}%</Progress>
                </td>
                <td style={{ width: '230px' }}>{weld.wps && Array.isArray(weld.wps) ?
                  weld.wps.map((wpsItem, index) => (
                    <span key={wpsItem.id}>
                      <a href={`/wps/${wpsItem.id}`} target="_blank"><i className="fa fa-link" /></a>
                      {`${wpsItem.no}(${wpsItem.rev_no})`}
                      <br />
                    </span>
                  )) :
                  weld.wps && <span>
                    <a href={`/wps/${weld.wps.id}`} target="_blank"><i className="fa fa-link" /></a>{`${weld.wps.no}(${weld.wps.rev_no})`}
                  </span>
                }</td>
                <td>{weld.welding_consumables && Array.isArray(weld.welding_consumables) ?
                  weld.welding_consumables.map((item, index) => (
                    <span key={item.id}>
                      {item.name}
                      {index < weld.welding_consumables.length - 1 && <br />}
                    </span>
                  )) : null
                }</td>
              </tr>
            </tbody>
          </table>

          {this.renderExtraData()}

          {weldInspections &&
            <table id="inspection-list-table" className='table'>
              <thead>
                <tr>
                  <th>Inspection Category</th>
                  {weldInspections.map((weldInspection, i) =>
                    <th
                      key={i}>{this.props.inspectionCategoryTypes.find(inspCat => Number(inspCat.id) === weldInspection.type_id).name}</th>)
                  }
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{weld.inspection_category.name}</td>
                  {weldInspections.map((weldInspection, i) => {
                    const typeName = this.props.inspectionCategoryTypes.find(inspCat => Number(inspCat.id) === weldInspection.type_id).name
                    const range = (weld.has_dimensional_control && typeName !== 'RI') ? Math.min(Math.round(weld.dc_weld_failed / weld.length * 100), 100) : weldInspection.range
                    return <td key={i}>{range}%</td>
                  })}
                </tr>
              </tbody>
            </table>
          }
        </CardBody>
      </Card>
    )
  }
})

export default WeldData



// WEBPACK FOOTER //
// ./src/components/Logs/WeldData.js